import {useTranslation} from 'react-i18next'

import {Typography} from '~/components/general/typography/Typography'
import {Container} from '~/components/general/container/Container'
import {SideModal} from '~/components/general/modal/SideModal'

type ServiceDetailsModalProps = {
  isVisible: boolean
  onClose: () => void
  serviceName: string
  location?: string | null
  contacts?: string | null
}

const displayValue = (value?: string | null) => value?.trim() || '–'

export const ServiceDetailsModal = ({
  isVisible,
  onClose,
  serviceName,
  location,
  contacts,
}: ServiceDetailsModalProps) => {
  const {t} = useTranslation()

  return (
    <SideModal
      isVisible={isVisible}
      onClose={onClose}
      header={
        <Typography size="lg" weight="medium">
          {serviceName}
        </Typography>
      }>
      <Container flex direction="column" spacing={3}>
        <Container flex direction="column" spacing={1}>
          <Typography weight="medium">{t('Location')}</Typography>
          <Typography>{displayValue(location)}</Typography>
        </Container>
        <Container flex direction="column" spacing={1}>
          <Typography weight="medium">{t('Contacts')}</Typography>
          <Typography>{displayValue(contacts)}</Typography>
        </Container>
      </Container>
    </SideModal>
  )
}
